import React from 'react';
import Helmet from 'react-helmet';

// Opens the connection where the deferred Maps script can actually be
// requested — see SearchMap's `enabled` gate.
export function MapsPreconnect() {
	return (
		<Helmet>
			<link
				rel="preconnect"
				href="//maps.googleapis.com"
			/>
		</Helmet>
	);
}

export default MapsPreconnect;
